// extracted by mini-css-extract-plugin
module.exports = {"questionnaire_content":"index-module__questionnaire_content___5-6TC","questionnaire_ottr":"index-module__questionnaire_ottr___RI7Z0","cont_row":"index-module__cont_row___rMi-8"};